import script from "./TownSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./TownSelection.vue?vue&type=script&setup=true&lang=js"

import "./TownSelection.vue?vue&type=style&index=0&id=24ca6e0b&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ca6e0b"]])

export default __exports__